import { axiosInstance } from '../services/axiosInstance';
import catchAsync from '../utils/catchAsync';

export const addEmployeeAdvance = catchAsync(async (body) => {
  const { data } = await axiosInstance.post(
    '/api/resource/Employee Advance',
    body
  );
  return data;
});
export const updateEmployeeAdvance = catchAsync(async (body, id) => {
  const { data } = await axiosInstance.put(
    `/api/resource/Employee Advance/${id}`,
    body
  );
  return data;
});

export const getEmployeeAdvance = catchAsync(async () => {
  const { data } = await axiosInstance.get(
    '/api/resource/Employee Advance?fields=["name","status","advance_amount","employee_name"]'
  );
  return data;
});
export const deleteEmployeeAdvance = catchAsync(async (record) => {
  const { data } = await axiosInstance.delete(
    `/api/resource/Employee Advance/${record}`
  );
  return data;
});
export const getEmployeeAdvanceDetails = catchAsync(async (id) => {
  const { data } = await axiosInstance.get(
    `/api/resource/Employee Advance/${id}`
  );
  return data;
});
export const getPaymentDetails = catchAsync(async (id) => {
  const { data } = await axiosInstance.get(
    `/api/method/technoerp.services.get_payment_details_empolyees?type=Employee Advance&name=${id}`
  );
  return data;
});
export const getSalaryDeduction = catchAsync(async (id) => {
  const { data } = await axiosInstance.get(
    `/api/method/technoerp.services.create_salary_deduction?name=${id}`
  );
  return data;
});
